import React from 'react';

import NextImage from 'next/image';

export const AppImageCard: React.FC<{ image: string; alt: string }> = ({ image, alt }) => {
  return <NextImage alt={alt} height={200} src={image} width={295} />;
};
